export default "__VITE_ASSET__be28ebf2__"